import moment from 'moment';
import React, { Component } from 'react';

import '../Comprobantes.css';

import ComplementoNomina from './complementos/ComplementoNomina';

class ComprobanteNomina extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = this.props;

    const fechaInicial = data.FechaInicialPago || moment().subtract(15, 'days').toDate();
    const fechaFinal = data.FechaFinalPago || new Date();

    this.state = {
      data: {
        ...data,
        FechaPago: data.FechaPago || new Date(),
        FechaInicialPago: fechaInicial,
        FechaFinalPago: fechaFinal,
        NumDiasPagados: data.NumDiasPagados ?? moment(fechaFinal).diff(moment(fechaInicial), 'days'),
      },
    };
  }

  handleOnChange = (event) => {
    const newEvent = {
      ...this.state,
      ...event,
    };

    this.setState(newEvent);

    this.props.onChange(newEvent);
  };

  render() {
    const { data } = this.state;
    const { input } = this.props;

    return (
      <>
        <ComplementoNomina
          input={input}
          data={data}
          onChange={this.handleOnChange}
        />
      </>
    );
  }
}

export default ComprobanteNomina;
